class UserSearch {
    static DEFAULT_VALUE = {
        name: '',
        status: null,
        role: null,
    }

    constructor(obj) {
        this.role = obj.role
        this.name = obj.name
        this.status = obj.status
    }

    serialized() {
        const obj = {
            "name": this.name || '',
            "role_id": this.role?.value || 0,
            "status": this.status?.value || ''
        }
        const query = Object.keys(obj).map(k => `${k}=${obj[k]}`).join('&')

        return `?${query}`
    }
}

export default UserSearch